import { ReactNode } from "react";
import { Context } from "./context";
import { useEntityAttributes } from "./use-entity-attributes";
import { useEditorConfig } from "../config/use-config";

export function EntityAttributesProvider({
  children,
}: {
  children: ReactNode;
}) {
  const config = useEditorConfig();
  const query = useEntityAttributes(config);

  return <Context.Provider value={query}>{children}</Context.Provider>;
}
